import PageContent from "../parts/page-content/PageContent";

import { Translations } from "../localization/translations";
import { useTranslation } from "react-i18next";

import NotFoundBlock from "../components/NotFoundBlock";

const PageNotFound: React.FC = () => {
    const { t } = useTranslation();

    return (
        <PageContent
            title={t<string>(Translations.pages.title.pageNotFound)}
            showBreadcrumbs={true}
            showTitleBarCommands={true}
        >
            <NotFoundBlock/>
        </PageContent>
    );
};

export default PageNotFound;
